const initCallEventsForm = () => {
  const form = document.querySelector("form[id*=call_event]")
  if (!form) return

  const purposeSelect = form.querySelector("select#call_event_purpose")
  const purposeOtherWrapper = form.querySelector("li#call_event_purpose_description_input")

  if (purposeSelect && purposeOtherWrapper) {
    const toggle = () => {
      const isOther = purposeSelect.value === "other"
      purposeOtherWrapper.classList.toggle("hidden", !isOther)
      purposeOtherWrapper.querySelector("input, textarea")?.toggleAttribute("disabled", !isOther)
    }

    purposeSelect.addEventListener("change", toggle)
    form.addEventListener("submit", () => purposeSelect.value !== "other" && purposeOtherWrapper.remove())
    toggle()
  }

  const calleeTypeSelect = form.querySelector("select#call_event_callee_type")
  const purposesByCalleeType = purposeSelect?.dataset.purposesByCalleeType

  if (calleeTypeSelect && purposeSelect && purposesByCalleeType) {
    const purposesMap = JSON.parse(purposesByCalleeType)
    const allOptions = Array.from(purposeSelect.options).map(o => ({value: o.value, label: o.textContent}))
    const blankOption = allOptions.find(o => !o.value)
    const labelByValue = new Map(allOptions.filter(o => o.value).map(o => [o.value, o.label]))

    const updatePurposes = () => {
      const allowedPurposes = purposesMap[calleeTypeSelect.value] || []
      const allowedPurposesOrdered = [...allowedPurposes.filter(v => v !== "other"),...(allowedPurposes.includes("other") ? ["other"] : [])]
      const currentValue = purposeSelect.value

      purposeSelect.innerHTML = ""
      if (blankOption) purposeSelect.add(new Option(blankOption.label, blankOption.value))
      allowedPurposesOrdered.filter(v => labelByValue.has(v)).forEach(v => purposeSelect.add(new Option(labelByValue.get(v), v)))

      purposeSelect.value = allowedPurposes.includes(currentValue) ? currentValue : ""
      purposeSelect.dispatchEvent(new Event("change"))
    }

    calleeTypeSelect.addEventListener("change", updatePurposes)
    updatePurposes()
  }

  const typeInputs = form.querySelectorAll('input[name="call_event[assignee_type]"]')
  const select = form.querySelector("select#call_event_assignee_id")
  if (!select || !typeInputs.length) return

  const groups = Array.from(select.querySelectorAll("optgroup")).map(g => ({
    label: g.label.toLowerCase().replace(/\s+/g, ""),
    options: Array.from(g.querySelectorAll("option")).map(o => ({text: o.textContent, value: o.value}))
  }))

  const buildOptions = () => {
    const type = Array.from(typeInputs).find(i => i.checked)?.value
    const key = (type === "Role" ? select.dataset.roleLabel : select.dataset.userLabel)?.toLowerCase().replace(/\s+/g, "")
    const group = groups.find(g => g.label.includes(key)) || groups[type === "Role" ? 0 : 1]
    
    const prev = select.value
    select.innerHTML = `<option value="">${select.dataset.promptText?.trim() || "Select option"}</option>`
    group?.options.forEach(o => select.add(new Option(o.text, o.value)))
    select.value = group?.options.some(o => o.value === prev) ? prev : ""
  }

  typeInputs.forEach(i => i.addEventListener("change", buildOptions))
  buildOptions()
}

document.addEventListener("DOMContentLoaded", initCallEventsForm)
document.addEventListener("turbo:load", initCallEventsForm)